import React from "react";
import Sidebar from "./Sidebar";

const Gallery = () => {
  return (
    <div style={{ display: "flex", minheight: "100vh" }}>
      {/* Sidebar on the left */}
      <Sidebar />

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Gallery</h2>

        {/* First two images side by side */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            marginBottom: "20px",
          }}
        >
          <img
            src="/gal1.jpg"
            alt="Gal 1"
            style={{
              width: "40%",
              maxWidth: "800px",
              borderRadius: "12px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
            }}
          />
          <img
            src="/gal3.jpg"
            alt="Gal 2"
            style={{
              width: "40%",
              maxWidth: "800px",
              borderRadius: "12px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
            }}
          />
        </div>

        {/* Third image below */}
        <img
          src="/gal2.jpg"
          alt="Gal 3"
          style={{
            width: "80%",
            maxWidth: "800px",
            borderRadius: "12px",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
          }}
        />
      </div>
    </div>
  );
};

export default Gallery;
